var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 내아이템 프리미엄 마켓 등록 "),_c('item-list-component',{attrs:{"item-type":_vm.myItemList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }